<template>
	<div>
		<a-form-model ref="addForm"  :model="param" :rules="rules"  :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }" >
			<a-form-model-item label="小区" prop="neighbor">
				<a-select  style="font-size: 0.6875rem;"
								v-model="param.neighbor" placeholder="请选择小区"
								option-filter-prop="children"  :filter-option="filterOption" 
								show-search  @change="queryGprs" :allowClear="true">
					<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item label="集中器" prop="gprs">
				<a-select  style="font-size: 0.6875rem;"   v-model="param.gprs" :allowClear="true">
					<a-select-option v-for="(item,index) in gprsList" :key="item.pId" :value="item.pId">{{item.gprsAddr}}</a-select-option>
				</a-select>
			</a-form-model-item>
			<a-form-model-item label="电表地址" prop="meterAddr">
				<a-input  v-model="param.meterAddr"/>
			</a-form-model-item>
		</a-form-model>
		<div class="drawerFooter">
		    <a-button icon="close" @click="onClose(false)" style="margin-right: 0.625rem;">取 消</a-button>
		    <a-button  icon="check" type="primary" :loading="submitFlag" @click="onSubmit">提 交</a-button>
		</div>
	</div>
</template>

<script>
	export default {
		props:[
			'neighborList',
		],
		data(){
			return {
				submitFlag:false,
				param:{
					neighbor:null,
					gprs:null,
					meterAddr:null,
				},
				rules:{
					neighbor:[{required:true,message:'请选择小区',trigger: 'blur'}],
					gprs:[
						{required:true,message:'请选择集中器',trigger: 'blur'},
					],
					meterAddr:[{required:true,message:'请输入电表地址',trigger: 'blur'}],
				},
				gprsList:[],
			}
		},
		methods:{
			onClose(flag){
				this.$emit('closeView');	
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			queryGprs:function(){
				let url = this.Api.getLastUrl(this.Api.READ_METER_GPRS_LIST_URL);
				let param = {neighborId:this.param.neighbor};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.gprsList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				})
			},
			onSubmit:function(){
				this.$refs.addForm.validate(valid => {
					if(valid) {
						this.doSubmit();
					} else {
						return false;
					}
				});
			},
			doSubmit:function(){
				this.submitFlag = true;
				let url = this.Api.getLastUrl(this.Api.ELEC_ADD_METER_URL);
				this.Api.fetchPostWithForm(url,this.param).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.onClose(true);
						this.$message.success('添加电表成功');
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.submitFlag = false;
				})
			},
		},
		
	}
</script>

<style>
</style>
